/**
 * Created by Christof Sander on 19.10.2016.
 */

var utils = require('frontend-controller/lib/utils');

module.exports = {
	extends: [
		'/',
		'templates',
		'mediaManagement',
		'actionsForm'
	],

	config: {
		type: 'filter'
	},

	model: {
		tags: {
			listOfCategoryDataIDs: [],
			data: []
		}
	},

	methods: {
		showFilter: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			var self = this;
			if(buttonContext === 'tags'){
				if(!self.model.tagPickerButton){
					self.closest(self.config.actionBossComponentClass, function(image){
						image.find('base_form_fields_tag-picker-button', function(tagPickerButton){
							self.model.tagPickerButton = tagPickerButton
						});
					});
				}

				self.model.tagPickerButton.open(self.model.tags.data, function(options){
					utils.forEach(((options || {}).decisionOptions || {}).dirtyAssignedTags || {}, function(tag){
						if(tag.type === 'delete'){
							self.model.tags.listOfCategoryDataIDs[tag.relationDataIndex] = 0;
							delete self.model.tags.data[tag.relationDataIndex];
						} else {
							self.model.tags.listOfCategoryDataIDs[tag.relationDataIndex] = tag.categoryDataID;
							self.model.tags.data[tag.relationDataIndex] = {
								attributes: tag
							};
						}
					});

					self.filterChanged();
				});
				return utils.promise.resolve();
			}

			return utils.promise.reject();
		},

		filterChanged: function(){
			var filters = utils.copy(((this.model.dirtyFields || {}).data || {}).attributes || {});

			if(this.config.type === 'filter') {
				filters.listOfCategoryDataIDs = this.model.tags.listOfCategoryDataIDs;
				filters.originalName = filters.originalName || '';
			} else {
				filters.order = {
					field: 		filters.orderField || 'mediaID',
					direction: 	filters.orderDirection || 'DESC'
				};
				delete filters.orderField;
				delete filters.orderDirection;
			}
			this.triggerClosest('filterChanged', { filters: filters });
		},

		onChange: function(isRelationChange, changeDone, fieldData){
			this.filterChanged();
		}
	}
};
